import { render, staticRenderFns } from "./understandingEducation.vue?vue&type=template&id=4f039284&scoped=true&"
import script from "./understandingEducation.vue?vue&type=script&lang=js&"
export * from "./understandingEducation.vue?vue&type=script&lang=js&"
import style0 from "./understandingEducation.vue?vue&type=style&index=0&id=4f039284&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f039284",
  null
  
)

export default component.exports